import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { IPartnerMessage, PartnerMessage } from "@/models/partner-message.entity";
import { MrfiktivPartnerMessageControllerFindAllByPartnerIdParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { getModule, Module } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { PartnerMessageDataAccessLayer } from "./access-layers/partner-message.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { IPartnerMessageStore } from "./inbox-message.store";
import { PartnerMessagePageDataProvider } from "./page-data-provider/partner-message.page-data-provider";

@Module({
  dynamic: true,
  namespaced: true,
  name: "reportmessages",
  store
})
export class ReportMessagesStore
  extends PaginatedBaseStore<IPartnerMessage, MrfiktivPartnerMessageControllerFindAllByPartnerIdParamsGen>
  implements IPartnerMessageStore {
  _data = PartnerMessageDataAccessLayer;
  _pageProvider = PartnerMessagePageDataProvider;
  _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = PartnerMessage.filterables;
  async reset() {
    // Do Nothing, resetting is handled in AllMessagesStore
  }
}

export const ReportMessagesModule = getModule(ReportMessagesStore);
